var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageMousetrail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8261 57H18.1739C16.9733 57 16 58.1739 16 59.622V97.3781C16 98.8261 16.9733 100 18.1739 100H53.8261C55.0267 100 56 98.8261 56 97.3781V59.622C56 58.1739 55.0267 57 53.8261 57Z",
    fill: "#718095",
    fillOpacity: 0.21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8261 49H38.1739C36.9733 49 36 50.1466 36 51.561V88.439C36 89.8534 36.9733 91 38.1739 91H73.8261C75.0267 91 76 89.8534 76 88.439V51.561C76 50.1466 75.0267 49 73.8261 49Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8804 41H60.1196C58.949 41 58 42.1193 58 43.5V79.5C58 80.8807 58.949 82 60.1196 82H94.8804C96.051 82 97 80.8807 97 79.5V43.5C97 42.1193 96.051 41 94.8804 41Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.826 30H82.1739C80.9733 30 80 31.1466 80 32.561V69.439C80 70.8534 80.9733 72 82.1739 72H117.826C119.027 72 120 70.8534 120 69.439V32.561C120 31.1466 119.027 30 117.826 30Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.826 19H110.174C108.973 19 108 20.1466 108 21.561V58.439C108 59.8534 108.973 61 110.174 61H145.826C147.027 61 148 59.8534 148 58.439V21.561C148 20.1466 147.027 19 145.826 19Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.207 106H67.9102C67.4075 106 67 106.406 67 106.907C67 107.408 67.4075 107.813 67.9102 107.813H166.207C166.71 107.813 167.117 107.408 167.117 106.907C167.117 106.406 166.71 106 166.207 106Z",
    fill: "#3C4148"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.136 109H70.8636C70.3867 109 70 109.448 70 110C70 110.552 70.3867 111 70.8636 111H164.136C164.613 111 165 110.552 165 110C165 109.448 164.613 109 164.136 109Z",
    fill: "#3C4148"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2 112H73.8C73.3582 112 73 112.448 73 113C73 113.552 73.3582 114 73.8 114H160.2C160.642 114 161 113.552 161 113C161 112.448 160.642 112 160.2 112Z",
    fill: "#3C4148"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.812 115H80.9102C80.4075 115 80 115.406 80 115.907C80 116.408 80.4075 116.813 80.9102 116.813H152.812C153.315 116.813 153.723 116.408 153.723 115.907C153.723 115.406 153.315 115 152.812 115Z",
    fill: "#3C4148"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.223 98H70.7623C68.1005 98 68 99.1193 68 100.5C68 101.881 68.1005 103 70.7623 103H163.223C165.885 103 166 101.881 166 100.5C166 99.1193 165.885 98 163.223 98Z",
    fill: "#D1D5DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.442 91H92.5503C91.0564 91 91 92.1193 91 93.5C91 94.8807 91.0564 96 92.5503 96H144.442C145.935 96 146 94.8807 146 93.5C146 92.1193 145.935 91 144.442 91Z",
    fill: "#D1D5DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.054 50.4484L134.073 35.5612C133.662 34.7947 134.358 33.9051 135.201 34.1196L151.75 38.3303C152.603 38.5475 152.779 39.6825 152.032 40.1482L149.107 41.9698C148.51 42.3417 148.473 43.1976 149.036 43.6192L155.154 48.1985C155.603 48.5341 155.688 49.1724 155.344 49.6141L153.992 51.3472C153.652 51.7828 153.024 51.8604 152.588 51.5205L146.41 46.6983C145.858 46.2673 145.045 46.5229 144.839 47.1924L143.891 50.2701C143.63 51.1191 142.474 51.2313 142.054 50.4484Z",
    fill: "#E8E8E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMousetrail);
export default __webpack_public_path__ + "static/media/image_mousetrail.bf93142642adc3d388dcee895c0b792d.svg";
export { ForwardRef as ReactComponent };